<script>
import { defineComponent } from 'vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import ApiTokensIndexPage from '@/pages/api-tokens/ApiTokensIndexPage.vue'

export default defineComponent({
  name: 'FundraiserApiTokensPage',
  components: { ApiTokensIndexPage },
  props: {
    fundraiserId: {
      type: Number,
      required: true
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserStore().getItemById(this.fundraiserId)
    }
  }
})
</script>

<template>
  <api-tokens-index-page v-if="fundraiser" :tokenable="fundraiser" />
</template>

<style scoped>

</style>
